// Auth API
import api from './client';

export interface RegistrationData {
  email: string;
  password: string;
  password_confirm: string;
  first_name: string;
  last_name: string;
  company_name?: string;
}

export const authAPI = {
  login: (email: string, password: string) =>
    api.post('/auth/login/', { email, password }),

  register: (data: RegistrationData) =>
    api.post('/auth/register/', data),

  logout: () =>
    api.post('/auth/logout/'),

  profile: () =>
    api.get('/auth/profile/'),

  updateProfile: (data: { first_name?: string; last_name?: string; phone?: string; job_title?: string }) =>
    api.put('/auth/profile/', data),

  status: () =>
    api.get('/auth/status/'),

  // Impersonation (Login As). viewCompanyId pins the post-impersonation
  // landing scope to the company the admin was inspecting (e.g. clicked
  // through from /suppliers/<id>) — without it the backend pins to the
  // target's home, which is wrong for multi-site users.
  impersonate: (userId?: number, userEmail?: string, viewCompanyId?: number) =>
    api.post('/auth/impersonate/', {
      user_id: userId,
      user_email: userEmail,
      view_company_id: viewCompanyId,
    }),

  stopImpersonate: (originalToken: string, auditLogId?: number) =>
    api.post('/auth/stop-impersonate/', {
      original_token: originalToken,
      ...(auditLogId ? { audit_log_id: auditLogId } : {}),
    }),

  getImpersonatableUsers: () =>
    api.get('/auth/impersonatable-users/'),

  // Password reset
  forgotPassword: (email: string) =>
    api.post('/auth/forgot-password/', { email }),

  validateResetToken: (token: string) =>
    api.get(`/auth/validate-reset-token/?token=${token}`),

  resetPassword: (data: { token: string; new_password: string; confirm_password: string }) =>
    api.post('/auth/reset-password/', data),
};
